import { post } from "../modules/HttpWebClient"

interface RequestParam {
  type: string
  email: string
  name: string
  contact: string
  comment: string
}
export async function requestDemo(param: RequestParam) {
  try {
    await post("/api/v1/inquiry", param)
    return true
  } catch (e) {
    alert("알 수 없는 에러입니다. 잠시 후 다시 시도해주세요")
  }
}
